import { render } from "./ComplianceDashboard.vue?vue&type=template&id=4ea07afc&scoped=true"
import script from "./ComplianceDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceDashboard.vue?vue&type=script&lang=js"

import "./ComplianceDashboard.vue?vue&type=style&index=0&id=4ea07afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea07afc"]])

export default __exports__